// Holiday lottery: the stamps around the entry form drift a little as the page scrolls, each at its
// own pace (data-drift: pixels moved per 100 px scrolled), so they seem to float above the skyline.
// Nothing moves for visitors who ask their device for less motion.

const stamps = document.querySelectorAll(".js-lottery-stamp");
const calm = window.matchMedia("(prefers-reduced-motion: reduce)");

if (stamps.length && !calm.matches) {
  let ticking = false;

  const drift = () => {
    const scrolled = window.scrollY;
    stamps.forEach((stamp) => {
      const pace = parseFloat(stamp.dataset.drift || "8") / 100;
      stamp.style.setProperty("--drift", `${(-scrolled * pace).toFixed(1)}px`);
    });
    ticking = false;
  };

  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(drift);
      }
    },
    { passive: true },
  );
  drift();
}
